import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getBuilders, getSellers } from '../../../selectors/newbuilding';
import { INewbuildingSeller } from '../../../types/newbuilding/seller';
import { INewbuildingBuilder } from '../../../types/newbuilding/builder';
import { BuilderChatCallContainer } from '../../BuilderChatCallContainer';

export function useChatButtonContextValue(forcedContacts?: {
  builders: INewbuildingBuilder[];
  sellers: INewbuildingSeller[];
}) {
  const builders = useSelector(getBuilders);
  const sellers = useSelector(getSellers);

  return useMemo(
    () => ({
      builders,
      sellers,
      ...forcedContacts,
      CallComponent: BuilderChatCallContainer,
    }),
    [builders, forcedContacts, sellers],
  );
}
